module.exports = __webpack_public_path__ + "static/media/upload.1560fd0e.svg";